/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/List", "react", "../../Resources", "../Common/KubeFilterBar"], function (require, exports, List_1, React, Resources, KubeFilterBar_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServicesFilterBar = /** @class */ (function (_super) {
        __extends(ServicesFilterBar, _super);
        function ServicesFilterBar() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._selection = new List_1.ListSelection(true);
            return _this;
        }
        ServicesFilterBar.prototype.render = function () {
            var svcTypes = this._generateSvcTypes();
            var items = [];
            for (var _i = 0, svcTypes_1 = svcTypes; _i < svcTypes_1.length; _i++) {
                var svc = svcTypes_1[_i];
                var item = {
                    id: svc,
                    text: svc
                };
                items.push(item);
            }
            ;
            return (React.createElement(KubeFilterBar_1.KubeFilterBar, { filter: this.props.filter, pickListPlaceHolder: Resources.TypeText, keywordPlaceHolder: Resources.ServiceText, filterToggled: this.props.filterToggled, selection: this._selection, listItems: items, className: this.props.className || "", addBottomPadding: true }));
        };
        ServicesFilterBar.prototype._generateSvcTypes = function () {
            var svcTypes = [];
            this.props.serviceList && this.props.serviceList.items && this.props.serviceList.items.forEach(function (svc) {
                if (svcTypes.indexOf(svc.spec.type) === -1) {
                    svcTypes.push(svc.spec.type);
                }
            });
            return svcTypes;
        };
        return ServicesFilterBar;
    }(React.Component));
    exports.ServicesFilterBar = ServicesFilterBar;
});
